// extracted by mini-css-extract-plugin
export default {"resumen":"movimientos_resumen__I2fVm","row":"movimientos_row__nvuJl"};